import { District as DistrictType } from '@/types';
import { supabase } from '@/integrations/supabase/client';

export class District {
  static async get(id: string): Promise<DistrictType> {
    const { data, error } = await supabase
      .from('districts')
      .select('*')
      .eq('id', id)
      .single();
    
    if (error) throw error;
    
    return {
      ...data,
      status: data.subscription_status || 'active',
      created_date: data.created_at
    } as DistrictType;
  }

  static async list(): Promise<DistrictType[]> {
    const { data, error } = await supabase
      .from('districts')
      .select('*')
      .order('name');
    
    if (error) throw error;
    
    return (data || []).map(d => ({
      ...d,
      status: d.subscription_status || 'active',
      created_date: d.created_at
    })) as DistrictType[];
  }

  static async create(data: Partial<DistrictType>): Promise<DistrictType> {
    const { data: created, error } = await supabase
      .from('districts')
      .insert([{
        name: data.name || '',
        ...data
      }])
      .select()
      .single();
    
    if (error) throw error;
    
    return {
      ...created,
      status: created.subscription_status || 'active',
      created_date: created.created_at
    } as DistrictType;
  }
}